import React, { useEffect, useRef } from 'react';
import { Button, Circle } from '@icecreamsocial/components';
import { CloseIcon } from '../SupportedIcons';

export const CloseButton = ({ ...rest }) => (
	<Circle as={Button} type="button" aria-label="Close" {...rest}>
		<CloseIcon style={{ pointerEvents: 'none' }} />
	</Circle>
);
